module.exports = __webpack_public_path__ + "static/img/YKYVehiclesBg.2a964cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/bg/YKYVehiclesBg.png
// module id = FHYj
// module chunks = 1